import { setConfig } from '@faustwp/core';
import templates from '@/wp-templates';
import possibleTypes from './possibleTypes.json';
import { CeremonyRewrite } from './faust-plugins/ceremony-rewrite';
import { RockHallTVRewrite } from './faust-plugins/rockhall-tv-rewrite';
import { LocaleRewrite } from './faust-plugins/locale-rewrite';
import { PersistedQueryRetry } from './faust-plugins/persisted-query-retry';

/**
 * @type {import('@faustwp/core').FaustConfig}
 **/
export default setConfig({
  templates,
  plugins: [
    new CeremonyRewrite(),
    new RockHallTVRewrite(),
    new LocaleRewrite(),
    // Workaround for the wpgraphql-smart-cache persisted-query registration race
    // (see ./faust-plugins/persisted-query-retry). On by default; set PQ_RETRY=off
    // to reproduce the baseline build failure.
    ...(process.env.PQ_RETRY === 'off' ? [] : [new PersistedQueryRetry()]),
  ],
  experimentalToolbar: false,
  usePersistedQueries: true,
  possibleTypes,
});
